import { Injectable } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';
import { ProductActivatorService } from '@frontend/vanilla/shared/product-activation';

@Injectable({ providedIn: 'root' })
export class HostAppBootstrapper implements OnAppInit {
    constructor(private productActivatorService: ProductActivatorService) {}

    async onAppInit(): Promise<void> {
        await this.productActivatorService.activate('host');
    }
}
